export interface ITokenKeyParams {
  token: string;
}

export const tokenKeys = {
  root: (params: ITokenKeyParams) => ['token', params.token] as const,
  status: (params: ITokenKeyParams) =>
    [...tokenKeys.root(params), 'fetch status'] as const,
};

export function parseTokenKey<T extends keyof typeof tokenKeys>(
  queryKey: ReturnType<typeof tokenKeys[T]>,
) {
  const [, token] = queryKey;

  return { token };
}
